/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Lot_List_Filter_PositionInputs */

const vi_lot_list_filter_position = /** @type {(inputs: Lot_List_Filter_PositionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vị trí trong kho`)
};

/**

* @param {Lot_List_Filter_PositionInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const lot_list_filter_position = /** @type {((inputs?: Lot_List_Filter_PositionInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Lot_List_Filter_PositionInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_lot_list_filter_position(inputs)
});